<template>
  <div class="d-flex justify-content-md-between flex-column flex-md-row mb-5">
    <div class="mb-3">
      <span>Välj energikälla:</span>
      <div class="my-2 d-flex" style="cursor: pointer;">
        <div v-for="num in 2" :key="num" @click="selectEnergySource(num)" :class="{ 'btn-secondary': selectedEnergySource == num }" class="border-end p-2">
          {{ num == "1" ? "Förnybar" : "Fossilfri"}}
        </div>
      </div>
    </div>

      <!-- Bygg nån lösning som filtrerar vilka elområden som finns att välja ens, exempelvis för bundet finns bara 2 och 3. Då behöver inte 1 och 4 visas som alternativ-->
    <div class="mb-3">
      <span>Välj elområde:</span>

      <div class="my-2 d-flex" style="cursor: pointer;">
        <div v-for="num in 4" :key="num" @click="selectArea(num)" :class="{ 'btn-secondary': se == num }" class="border-end p-2">
          SE{{ num }}
        </div>
      </div>
    </div>

    <!-- UI-komponent för att välja datumintervall -->
    <div class="mb-3">
      <span>Välj datumintervall:</span><br>
      <div class="my-2 d-flex" style="cursor: pointer;">
        <div v-for="range in [1, 3, 6, 12]" :key="range" @click="selectedRange = range" :class="{ 'btn-secondary': selectedRange == range }" class="border-end p-2">
          Senaste {{ range }} månaderna
        </div>
      </div>
    </div>

    <!-- UI-komponent för att välja visningsläge (diagram/tabell) -->
    <div v-if="false">
      <span>Visa som:</span><br>
      <div class="my-2 d-flex" style="cursor: pointer;">
        <div @click="displayTable = false" :class="{ 'btn-secondary': !displayTable }" class="border-end p-2">Diagram</div>
        <div @click="displayTable = true" :class="{ 'btn-secondary': displayTable }" class="p-2">Tabell</div>
      </div>
    </div>
  </div>

  <h2>Elområde {{ se }}</h2>

  <!-- Visar diagrammet om "displayTable" är falskt -->
  <div v-show="!displayTable">
    <LineChart :data="chartData" :options="chartOptions"></LineChart>
  </div>

  <!-- Här kan en tabell visas istället för diagram -->
  <div v-show="displayTable">
    <!-- Table implementation -->
  </div>
</template>

<script>
import { Chart as ChartJS, CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend, TimeScale } from 'chart.js';
import { Line } from 'vue-chartjs';
import 'chartjs-adapter-date-fns';

// Registrerar Chart.js komponenter som används i diagrammet
ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend, TimeScale);

export default {
  components: { LineChart: Line },
  props: {
    type: {
      type: String,
      default: 'alla', // Om ingen prop skickas in, används "alla"
      validator: value => ['rorligt', 'indexel', 'bundet', 'alla'].includes(value) || !value // Säkerställer giltiga värden, annars "alla"
   }
  },
  data() {
    return {
      // Fördefinierade färger för diagramserier
      colors: ['#47525d', '#8fc02f', '#cd0c4e', '#f28c00', '#e2c100', '#228a93'],
      se: 3, // Standardval för elområde
      selectedRange: 3, // Standardval för datumintervall
      series: [], // Data från API
      filteredSeries: [], // Filtrerad data som används i diagrammet
      displayTable: false, // Visningsläge (diagram eller tabell)
      xCategories: [], // Datumvärden på X-axeln
      maxValue: 0, // Maxvärdet för Y-axeln, ändras dynamiskt för att det är snyggare?, annars blir typ osynliga streck i botten på elområde 1. :D
      
      selectedEnergySource: "1",
      seriesLabels: [//Byt ut det fula namnet från apiet till produktens riktiga namn. :) Om ingen matchning finns här så visas det fula namnet.
        { key: 'rorligt', name: 'Rörligt Månad' },
        { key: 'timpriser', name: 'Rörligt Timme' },
        { key: 'indexel_manad', name: 'IndeXel Månad' },
        { key: 'indexel_timme', name: 'IndeXel Timme' },
        { key: 'bundet_1_ar', name: 'Bundet Profilpris 1 år' },
        { key: 'bundet_2_ar', name: 'Bundet Profilpris 2 år' }
      ]
    };
  },

  computed: {
    // Konfigurerar data för Chart.js
    chartData() {
      return {
        labels: this.xCategories,
        datasets: this.filteredSeries.map((serie, index) => ({
          label: this.seriesLabels.find(label => label.key === serie.name)?.name || serie.name,
          data: serie.data.map(dp => ({ x: dp.x, y: dp.y, filled: dp.filled })),
          borderColor: this.colors[index % this.colors.length],
          backgroundColor: this.colors[index % this.colors.length],
          segment: { borderDash: ctx => this.filled(ctx, [6, 6]) },
          tension: 0.1,
          pointStyle: false,
        })),
      };
    },
    // Diagraminställningar för Chart.js
    chartOptions() {
      return {
        responsive: true,
        interaction: { mode: 'index', intersect: false },
        locale: 'sv-SE',
        scales: {
          x: { type: 'time', time: { unit: 'day', displayFormats: { day: 'yyyy-MM-dd' } } },
          y: { beginAtZero: true, max: this.maxValue }
        }
      };
    }
  },

  methods: {
    selectEnergySource(selectedEnergySource) {
console.log(selectedEnergySource)
    this.selectedEnergySource = selectedEnergySource
   
      this.filterData()
    },
    // Funktion för att göra streckade linjer för interpolerade datapunkter
    filled(ctx, value) {
      return ctx.p0.raw.filled || ctx.p1.raw.filled ? value : undefined;
    },
    
    // Ändrar valt elområde och uppdaterar datan
    selectArea(area) {
      this.se = area;
      this.filterData();
    },
    
    // Hämtar elpriser från API:t
    fetchPrices() {
          // Säkerställer att en ogiltig "type" tolkas som "alla"
          const validType = ['rorligt', 'indexel', 'bundet'].includes(this.type) ? this.type : 'alla';
      
      // Bygger API-URL beroende på vilken "type" som skickas in
      let url = `https://apps.gavleenergi.se/powerplant-webservice/servicepoint/historiska-elpriser/bundle/`;
      if (validType !== 'alla') {
        url += `?type=${validType}`;
      }
      
      fetch(url, {
        headers: { 'X-API-KEY': process.env.VITE_API_KEY }
      })
        .then(res => res.ok ? res.json() : Promise.reject(`Error: ${res.statusText}`))
        .then(json => {
          this.fulljson = json;
          this.filterData();
        })
        .catch(console.error);
    },
    // Filtrerar data baserat på valt elområde, datumintervall och energikälla
filterData() {
  // Beräknar det datum som ligger "selectedRange" månader bakåt i tiden
  const pastDate = new Date();
  pastDate.setMonth(pastDate.getMonth() - this.selectedRange);
  const area = this.se;

  // Kontrollera om data finns för det valda elområdet
  if (!this.fulljson || !this.fulljson.rorligt?.[area]) return;

  // Extrahera och filtrera serier från JSON-svaret
  this.series = Object.keys(this.fulljson).map(type => {
    const rawData = this.fulljson[type][area] || [];

    // Filtrera så att endast datapunkter där electricity_source matchar selectedEnergySource behålls
    const filteredData = rawData
      .filter(dp => {
        const energySource = dp.electricity_source ?? "1"; // Om electricity_source saknas, anta att det är "1"
        return energySource == this.selectedEnergySource;
      })
      .map(dp => ({
        x: dp.period,
        y: parseFloat(dp.price),
        filled: false
      }));

    return filteredData.length > 0 ? { name: type, data: filteredData } : null;
  }).filter(Boolean); // Tar bort null-värden (serier som inte matchar)

  // Fyll i saknade datum med senaste kända värde
  this.filteredSeries = this.series.map(serie => {
    let filledData = [], lastValue = null, dateMap = new Map(serie.data.map(dp => [dp.x, dp]));
    for (let d = new Date(pastDate); d <= new Date(); d.setDate(d.getDate() + 1)) {
      let dateStr = d.toISOString().split('T')[0];
      filledData.push(dateMap.get(dateStr) || (lastValue ? { ...lastValue, x: dateStr, filled: true } : null));
      if (dateMap.has(dateStr)) lastValue = dateMap.get(dateStr);
    }
    return { ...serie, data: filledData.filter(Boolean) };
  });

  // Skapa en unik lista över alla datum på X-axeln
  this.xCategories = [...new Set(this.filteredSeries.flatMap(serie => serie.data.map(dp => dp.x)))].sort();

  // Beräkna maxvärdet för Y-axeln genom att avrunda till närmaste tiotal
  this.maxValue = Math.ceil(Math.max(...this.filteredSeries.flatMap(serie => serie.data.map(dp => dp.y))) / 10) * 10;
},



  },

  watch: {
    se: 'filterData',
    selectedRange: 'filterData'
  },

  mounted() {
    this.fetchPrices();
  }
};
</script>

<style>
/* Stil för UI-element */
</style>
